export default [
	{
		path: "/pros/channels",
		exact: true,
		policy: "providerAuth",
		component: "Channels",
		mui: true,
	},
];
